import { Pipe, PipeTransform, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { RoleCssProviderService } from '../providers/role-css-provider.service';
import { Role } from '../enums/role';

@Pipe({
  name: 'roleCss',
  standalone: true,
})
export class RoleCssPipe implements PipeTransform {
  private readonly provider = inject(RoleCssProviderService);

  public transform(role: Role): Observable<string> {
    return this.provider.css(role);
  }
}
